import React from 'react';
import { Redirect, useLocation, useParams } from 'react-router-dom';

interface ILegacyPublicRedirectProps {
  base: string;
}

// Keeps already-sent `/public/...` email/SMS links alive after the move to the
// `/parent` base. `<Redirect>` drops the query string, so the access `token`
// (and any RSVP deep-link params) are carried over explicitly via location.search.
export const LegacyPublicRedirect: React.FC<ILegacyPublicRedirectProps> = ({ base }) => {
  const { code, playerAssessmentId } = useParams<{ code: string; playerAssessmentId: string }>();
  const { search } = useLocation();

  return <Redirect to={`${base}/${code}/${playerAssessmentId}${search}`} />;
};
